export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-w@3x.e6a202c3.png";